<app-autocomplete-select
  [options]="options"
  [searchFn]="search"
  [preloadFn]="preload"
  [placeholder]="placeholder"
  [selectClass]="selectClass"
  [disabled]="isDisabled"
  [ngModel]="value"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="valueChanged($event)"
></app-autocomplete-select>
<small class="form-hint d-block" *ngIf="loadingDefault" role="status">Loading organisation currency…</small>
<div class="text-danger small" *ngIf="defaultError" role="alert">
  {{ defaultError }}
  <button class="btn btn-link btn-sm p-0" type="button" [disabled]="isDisabled" (click)="loadDefault()">Retry currency</button>
</div>
